"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticationFactory = void 0;
const Factory = require("factory.ts");
exports.authenticationFactory = Factory.Sync.makeFactory({
    access_token: 'abcdef1234567890',
    token_type: 'bearer',
    expires_at: 1614803080,
    expires_in: 86400,
    refresh_token: 'bacdef1234567890',
    session_id: 'session-test-uuid-goes-here',
});
